"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Single = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const ErrorBoundary_1 = require("../ErrorBoundary");
const Layout_1 = require("../Layout");
const FlexWrapper = (0, styled_components_1.styled)(Layout_1.InnerPanel) `
  flex: 1;
  margin: 0;
  display: flex;
  flex-direction: column;
  padding: 0;
  container: main / size;
`;
const Header = styled_components_1.styled.header `
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  background: #333;
  box-shadow: 0 2px 3px #0003;
  z-index: 5;
`;
const Main = styled_components_1.styled.div `
  width: 100%;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;
const Single = (props) => (
// IMPORTANT - id main is required for popup components scroll events
react_1.default.createElement(FlexWrapper, { id: "main" },
    props.header && (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null,
        react_1.default.createElement(Header, null, props.header))),
    react_1.default.createElement(Main, null,
        react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null, props.children))));
exports.Single = Single;
//# sourceMappingURL=Single.js.map